import React from "react";
import * as Mui from "@mui/material";
import { makeStyles } from "tss-react/mui";
import * as Icons from "react-feather";
import { Agent } from "model/agent";

const useStyles = makeStyles()((theme) => ({
	paper: { maxWidth: 480, width: "100%" },
	title: { display: "flex", alignItems: "center", justifyContent: "space-between" },
	actions: { padding: theme.spacing(2) },
	button: { textTransform: "none", fontWeight: 600, borderRadius: 8 },
}));

interface Props {
	open: boolean;
	agent: Agent;
	onCancel: () => void;
	onConfirm: () => void;
}

/** Remove Team Member confirmation (Access tab). Copy per Figma. Uses the deleteAgent thunk. */
export const RemoveMemberModal: React.FC<Props> = ({ open, agent, onCancel, onConfirm }) => {
	const { classes } = useStyles();
	return (
		<Mui.Dialog open={open} onClose={onCancel} classes={{ paper: classes.paper }}>
			<Mui.DialogTitle>
				<div className={classes.title}>
					<Mui.Typography variant="h6" style={{ fontWeight: 700 }}>Remove Team Member</Mui.Typography>
					<Mui.IconButton size="small" onClick={onCancel}><Icons.X size={20} /></Mui.IconButton>
				</div>
			</Mui.DialogTitle>
			<Mui.DialogContent>
				<Mui.Typography gutterBottom>
					This will permanently remove <strong>{agent.name}</strong> from your team and unassign their leads. We recommend reassigning their leads before removing them.
				</Mui.Typography>
				<Mui.Typography><strong>This action cannot be undone.</strong></Mui.Typography>
			</Mui.DialogContent>
			<Mui.DialogActions className={classes.actions}>
				<Mui.Button className={classes.button} variant="outlined" color="primary" onClick={onCancel}>Cancel</Mui.Button>
				<Mui.Button className={classes.button} variant="contained" color="primary" onClick={onConfirm}>Remove Team Member</Mui.Button>
			</Mui.DialogActions>
		</Mui.Dialog>
	);
};
